import useRulesState from "./useRulesState";
import {deleteRuleRequest, updateRuleRequest} from "../../../../services/api";

const useRulesInfo = (checkRules) => {
  const {rulesInfo, deleteRuleFromState, updateRuleFromState} = useRulesState(checkRules);

  const RuleActions = {
    deleteRule: (id) => {
      return new Promise((resolve) => {
        deleteRuleRequest(id)
          .then(() => {
            deleteRuleFromState(id);
            resolve();
          });
      });
    },

    updateRule: (ruleData, id) => {
      return new Promise((resolve) => {
        updateRuleRequest(ruleData, id, false)
          .then((response) => {
            updateRuleFromState(response.data, id);
            resolve();
          });
      });
    }
  };

  return {
    rulesInfo,
    RuleActions
  };
};

export default useRulesInfo;